import Token from "./Token";
import { TokenDistribution } from "@/features/tokens";

export default function ManagerUsage() {
  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-5 overflow-y-auto bg-transparent p-0">
      <div className="flex-shrink-0">
        <Token />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <TokenDistribution />
      </div>
    </div>
  );
}
